export function hasPagination(result) {
    if (Array.isArray(result)) {
        return false;
    }
    const paginatedResult = result;
    return (paginatedResult.data !== undefined &&
        paginatedResult.total !== undefined &&
        paginatedResult.limit !== undefined &&
        paginatedResult.skip !== undefined);
}
export function isSystemUser(user) {
    return user.systemUser === true;
}
//# sourceMappingURL=typeGuards.js.map